import React from 'react';
import { Link } from 'react-router-dom';
import { Bookmark, BookOpen, BookText } from 'lucide-react';
import { useBookmarks } from '../hooks/useBookmarks';

const Bookmarks = () => {
  const { bookmarks, toggleBookmark } = useBookmarks();

  return (
    <div className="space-y-8">
      <div className="page-header">
        <p className="page-header-om" aria-hidden="true">ॐ</p>
        <h1 className="page-header-title">Bookmarks</h1>
        <p className="page-header-desc">Your saved verses from the Bhagavad Gita.</p>
      </div>

      {bookmarks.length === 0 ? (
        <div className="text-center py-16">
          <BookText className="w-16 h-16 text-gray-300 mx-auto mb-4" />
          <p className="text-gray-500 mb-2">No bookmarks yet.</p>
          <p className="text-sm text-gray-400 mb-6">Open any verse and tap the bookmark icon to save it here.</p>
          <Link to="/chapters" className="btn-primary">Browse Chapters</Link>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {bookmarks.map((b) => (
            <div key={b.id} className="card p-6 flex flex-col gap-3">
              <div className="flex items-start justify-between gap-3">
                <Link
                  to={`/sloka/${b.id}`}
                  className="text-gita-maroon font-semibold hover:underline leading-snug"
                >
                  Chapter {b.chapterNumber} · Verse {b.slokaNumber}
                </Link>
                <button
                  type="button"
                  onClick={() => toggleBookmark(b)}
                  className="text-gita-gold hover:text-gray-400 transition-colors shrink-0 mt-0.5"
                  aria-label="Remove bookmark"
                >
                  <Bookmark className="w-5 h-5 fill-current" />
                </button>
              </div>

              {b.sloka && (
                <p className="text-sm text-gray-500 italic line-clamp-2 leading-relaxed">{b.sloka}</p>
              )}
              {b.meaning && (
                <p className="text-sm text-gray-700 line-clamp-2 leading-relaxed">{b.meaning}</p>
              )}

              <Link
                to={`/sloka/${b.id}`}
                className="btn-secondary text-sm self-start flex items-center mt-1"
              >
                <BookOpen className="w-4 h-4 mr-2" />
                Read verse
              </Link>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Bookmarks;
